import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { RTLProvider } from '@/contexts/RTLContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { GlobalStyles } from '@/styles/GlobalStyles';
import { theme } from '@/styles/theme';
import { router } from '@/routes';
import { ToastProvider } from '@/components/ui';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import OfflineIndicator from '@/components/common/OfflineIndicator';
import { useEffect } from 'react';
import { initMetaPixel, saveFbTracking } from '@/utils/metaPixel';

function App() {
  // Initialize Meta Pixel early so _fbp cookie is set on first page load,
  // and persist fbclid/fbp to localStorage so they survive the Hyp redirect.
  // IMPORTANT: saveFbTracking() uses a module-level snapshot of fbclid captured
  // at import time, so it's safe to call before or after pixel init.
  useEffect(() => {
    // Save fbclid to localStorage immediately (before pixel can strip it from URL)
    saveFbTracking();

    const pixelId = import.meta.env.VITE_META_PIXEL_ID;
    if (pixelId) {
      initMetaPixel(pixelId);
    }
    // Re-save after pixel has had time to set _fbp cookie
    const timer = setTimeout(() => saveFbTracking(), 800);
    return () => clearTimeout(timer);
  }, []);
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <RTLProvider>
          <AuthProvider>
            <GlobalStyles />
            <ToastProvider />
            <OfflineIndicator />
            <RouterProvider router={router} />
          </AuthProvider>
        </RTLProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
